import Node from './node';
import InnovationDB from './innovatinoDB';
import * as util from './util';

class Connection {
  from: Node;
  to: Node;

  weight: number;
  enabled: boolean;
  id: number;
  innovNumber: number;

  constructor(
    from: Node,
    to: Node,
    innovDB: InnovationDB,
    weight?: number,
    enabled = true,
    innovNumber?: number,
  ) {
    this.from = from;
    this.to = to;
    this.weight = weight || util.uniformRandom();
    this.enabled = enabled;

    // I used pairing function to uniquely encode to numbers(from, to) into a single number
    // https://en.wikipedia.org/wiki/Pairing_function#Cantor_pairing_function
    const k1 = this.from.number,
      k2 = this.to.number;
    this.id = ((k1 + k2) * (k1 + k2 + 1)) / 2 + k2;

    if (innovNumber === undefined) {
      this.innovNumber = innovDB.addInnovation(this.id);
    } else {
      this.innovNumber = innovNumber;
    }
  }
}

export default Connection;
